import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { StateCountryStore } from './state-country.store';
import { filter, type Observable, take } from 'rxjs';
import type { StateCountry } from './state-country.type';

export function stateCountryResolver(): Observable<Array<StateCountry>> {
  const statesStore = inject(StateCountryStore);
  statesStore.load();
  return toObservable(statesStore.states).pipe(
    filter((states) => states.length > 0),
    take(1),
  );
}
